<template>
  <basic-container>
    <el-form
      id="payErrorquery"
      ref="searchForm"
      :model="query"
      label-width="100px"
      margin-top="0"
      :rules="rules"
    >
      <el-row :gutter="0">
        <el-col :span="5">
          <!-- <el-form-item label="速记码" prop="shortCode">
            <el-input
              v-model="query.shortCode"
              @input="propertyFilter()"
              placeholder="速记码"
            ></el-input>
          </el-form-item> -->
          
          <el-form-item label="小区分组" prop="communityGroup">
            
            <el-select style="width: 100%" v-model="query.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="小区名称" prop="propertyId">
            
                <avue-input-tree 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="query.propertyId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="allPropertyListCopy"
                >
                </avue-input-tree>
            <!-- <el-select v-model="query.propertyId" placeholder="请选择小区" style="width: 100%">
              <el-option
                v-for="item in allPropertyListCopy"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="全部" style="width: 100%">
              <el-option
                v-for="item in allPayTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="收费日期 从" prop="dateRange">
            <el-date-picker
              style="width:42%;"
              v-model="query.dateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.dateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
           
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="缴费人" prop="householdName">
            <el-input v-model="query.householdName" placeholder="缴费人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="缴费来源" prop="payCost">
            <!-- <el-input v-model="query.payCost" placeholder="缴费来源"></el-input> -->
             <el-select v-model="query.payCost" placeholder="全部" style="width: 100%">
              <el-option
                v-for="item in allPayCostList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="text-align:right;">
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            @click.prevent="submitSearchForm"
            >搜索</el-button
          >
          <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      @tree-load="treeLoad"
    >

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-refresh"
          v-if="scope.row.feeSortCount !== ''"
          @click="updateBill(scope.row)"
          >状态更新
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  payErrorPageTree,
  payQuery,
  payQueryV1,
  payPageChildren,
  remove,
  update,
} from '@/api/v4ward/paylist/feepaylist';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import { getDictionary, getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';
import printPreview from '@/views/v4ward/pay/printdialog/printPreview';
import feeReturnApplyDialog from '@/views/v4ward/feereturn/feereturn-apply';
import InvoiceApplyDialog from './invoice-apply-dialog';

export default {
  components: { printPreview, feeReturnApplyDialog, InvoiceApplyDialog },
  data() {
    return {
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
      //如果已经根据速记码查询过了小区信息则为true
      communityGroupList:[],
      propertyIsQuery: false,
      payAmountSum: '',
      shouldAmountSum: '',
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [],
      allPropertyListCopy: [],
      allSortTypeList: [],
      allPayCostList: [],
      payCostList:[],
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      propertyName: '',
      form: {},
      query: {
        communityGroup:"",
        shortCode: '',
        propertyId: '',
        feeSort: '',
        dateFrom: '',
        dateTo: '',
        householdName: '',
        invoiceNo: '',
        payType: '',
        payCost:'',
       
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // height: 'auto',
        lazy: true,
        rowKey: 'id',
        calcHeight: 30,
        tip: false,
        border: true,
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '地址',
            prop: 'roomName',
            width: 180,
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '费项名称',
            prop: 'feeSort',
            slot: true,
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
          },
          {
            label: '抵扣金额',
            prop: 'accountpayAmount',
          },
          {
            label: '优惠金额',
            prop: 'derateAmount',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '缴费来源',
            prop: 'payCost',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_cost',
            dataType: 'number',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    let this_ = this;
    this.initDefaultDateRange();
    // this.initPropertyList();
    this.initSortTypeList();
    this.initPayTypeList();
    this.initPayCostList();
    
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.query.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              this.query.propertyId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              this.onLoad();
          });
      });
  },
  methods: {

        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
            this.initPropertyList((data)=>{
              this.query.propertyId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              // this.onLoad();
            });
        },
    treeLoad(tree, treeNode, resolve) {
      payPageChildren(tree.id).then((data) => {
        console.log(data.data);
        resolve(data.data);
      });
    },
    showAuditBtn(feeSortCount) {
      return feeSortCount !== '' && this.vaildData(this.permission.feereturn_apply, false);
    },
    showInvoiceApplyBtn(row) {
      let notApplied = row.invoicingFlag == 0;
      let rightStatus = row.payStatus == 1;
      // notApplied = true;
      return notApplied && rightStatus && this.vaildData(this.permission.invoice_apply, false);
    },
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.propertyId = '';
      }
      if (this.allPropertyListCopy.length > 0){
        // this.query.propertyId = this.allPropertyListCopy[0].id;
        this.query = Object.assign({},this.query,{propertyId:this.allPropertyListCopy[0].id});
      }
      else this.query.propertyId = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query);
      this.initDefaultDateRange()
      this.propertyFilter();
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    onLoad(page) {
   
      if (this.propertyIsQuery && !this.query.propertyId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.propertyId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if (!this.query.propertyId) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          payErrorPageTree(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipageQuery.total;
            this.data = data.ipageQuery.records;
            this.shouldAmountSum = data.shouldAmountSum;
            this.payAmountSum = data.payAmountSum;
            this.loading = false;
            this.selectionClear();
          });
        });
        return;
      }
      payErrorPageTree(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      ).then(({ data }) => {
        this.page.total = data.ipageQuery.total;
        this.data = data.ipageQuery.records;
        this.shouldAmountSum = data.shouldAmountSum;
        this.payAmountSum = data.payAmountSum;
        this.loading = false;
        this.selectionClear();
      });
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.query.dateFrom=this.getCurrentMonthFirst() + " 00:00:00.000"
      this.query.dateTo=this.getCurrentMonthLast() +" 23:59:59.999"
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPropertyList(cb) {
      let this_ = this;
      getOptionNode({communityGroup:this_.query.communityGroup}).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
        cb(data.data);
      });
    },

    initSortTypeList: function () {
      getDictionary('fee_sort').then((data) => {
        this.allSortTypeList = data.data;
      });
    },

    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },

    initPayCostList: function () {
      getDictionary('pay_cost').then((data) => {
        console.log('data==>',data);
        this.allPayCostList = data.data;
      });
    },

    updateBill(row) {
      if(row.payCost == 11){
        //V1版本收费使用
        payQueryV1(
          Object.assign({ paybillNo: row.payBillNo},null)
        ).then(({ data }) => {
          if(data.payStatus == 1){
            //交易成功
            this.$message.success("订单支付，状态更新成功！");
            this.onLoad();
          }else{
            //交易失败
            this.$message.warning("订单未支付，请稍后查询！");
          }
        });
      }
      else{
        payQuery(
          Object.assign({ payBillNo: row.payBillNo},null)
        ).then(({ data }) => {
          if(data.tradeStatus == 2){
            //交易成功
            this.$message.success("订单支付，状态更新成功！");
            this.onLoad();
          }else{
            //交易失败
            this.$message.warning("订单未支付，请稍后查询！");
          }
        });
      }

    },

  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}

.el-dialog__body .el-card__body {
  padding: 0;
}

.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>
